import React, { Component } from "react";
import BlockUi from "react-block-ui";
import { connect } from "react-redux";
import Select from "react-select";
import YearPicker from "react-year-picker";
import { Button, Container, FormGroup, Label } from "reactstrap";
import DropDown from "shared/components/DropDown/index";
import simpleReactValidator from "simple-react-validator";
import * as XLSX from "xlsx";
import { appendCDN } from "../../../utils/dist";
import { fetchFacilityList, fetchGroupList, getPeriodicalStatusReport } from "../../actions/actions";

class ConsolidateReport extends Component {
  constructor(props) {
    super(props);
    this.dispatch = this.props.dispatch;
    this.datepickerRef = null;
    this.validator = new simpleReactValidator();
    this.state = {
      loading: false,
      selectedYear: new Date().getFullYear(),
      recordNotFound: false,
      recordNotFoundMessage: {},
      isSelectAll: false,
      facilityId: [],
      groupId: "",
      organizationList: [],
      facilityListByOrganization: [],
      data: {},
    };
    this.setDatepickerRef = this.setDatepickerRef.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.searchForReport = this.searchForReport.bind(this);
    this.handleGroupChange = this.handleGroupChange.bind(this);
    this.handleFacilityChange = this.handleFacilityChange.bind(this);
    this.selectAllFacility = this.selectAllFacility.bind(this);
  }

  componentDidMount() {
    appendCDN();

    this.datepickerRef.state.currentYear = new Date().getFullYear();
    this.datepickerRef.state.selectedYear = new Date().getFullYear();

    this.dispatch(fetchGroupList());
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.periodical_status_report_data !== prevProps.periodical_status_report_data) {
      this.setState(() => {
        return {
          ...prevState,
          data: this.props.periodical_status_report_data,
          loading: false,
          recordNotFoundMessage: Object.keys(this.props.periodical_status_report_data).length === 0 ? { message: "No records found" } : {},
        };
      });
    }

    if (this.props.group_items !== prevProps.group_items) {
      this.setState(() => {
        return {
          ...prevState,
          organizationList: this.props.group_items,
          loading: false,
        };
      });
    }

    if (this.props.facility_data !== prevProps.facility_data) {
      this.setState(() => {
        return {
          ...prevState,
          facilityListByOrganization: this.props.facility_data,
          facilityId: this.props.facility_data.map(({ name, id }) => ({ label: name, value: id })),
          isSelectAll: true,
          loading: false,
        };
      });
    }
  }

  handleGroupChange(event) {
    let groupId = event.target.value;
    this.setState((prevState) => {
      return {
        ...prevState,
        facilityId: [],
        loading: true,
        groupId,
        recordNotFoundMessage: {},
        recordNotFound: false,
      };
    });
    this.dispatch(fetchFacilityList(groupId));
  }

  handleFacilityChange(event) {
    this.setState((prevState) => {
      return {
        ...prevState,
        facilityId: event,
        recordNotFoundMessage: {},
        recordNotFound: false,
        isSelectAll: false,
      };
    });
  }

  selectAllFacility(event) {
    let isAllSelected = event.target.value === "true" ? true : false;

    if (!isAllSelected) {
      this.setState((prevState) => {
        return {
          ...prevState,
          facilityId: this.state.facilityListByOrganization.map(({ name, id }) => ({ label: name, value: id })),
          isSelectAll: !this.state.isSelectAll,
        };
      });
    } else {
      this.setState((prevState) => {
        return {
          ...prevState,
          facilityId: [],
          isSelectAll: !this.state.isSelectAll,
        };
      });
    }
  }

  handleDateChange(date) {
    this.setState((prevState) => {
      return {
        ...prevState,
        selectedYear: date,
        recordNotFoundMessage: {},
        recordNotFound: false,
      };
    });
  }

  validateFormFields(fields = []) {
    var that = this;
    let isValid = true;

    for (let i = 0; i < fields.length; i++) {
      let field = fields[i];
      if (!that.validator.fieldValid(field)) {
        isValid = false;
        break;
      }
    }

    if (!isValid) {
      that.validator.showMessages();
      that.forceUpdate();
    }

    return isValid;
  }

  searchForReport() {
    if (this.validateFormFields(["selected_group", "selected_facility"])) {
      const facilityIds = this.state.facilityId.map((facility) => facility.value).join(",");

      this.setState((prevState) => {
        return {
          ...prevState,
          loading: true,
        };
      });

      let body = {
        year: +this.state.selectedYear,
        org_id: String(+this.state.groupId),
        facility_id: this.state.isSelectAll ? 0 : facilityIds,
      };

      this.dispatch(getPeriodicalStatusReport(body)).then(() => {
        this.setState((prevState) => {
          return {
            ...prevState,
            loading: false,
          };
        });
      });
    }
  }

  setDatepickerRef(ref) {
    this.datepickerRef = ref;
  }

  getMonthHeaders() {
    return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  }

  createExcelFile(data) {
    // Format the data to match the structure of the Excel file
    const sheetData = [];

    sheetData.push(["Facility Name", "Periodical", "Frequency", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]);
    Object.entries(data).forEach(([state, facilities]) => {
      // Add a header row for the state
      sheetData.push([state]);

      // Iterate through facilities
      Object.entries(facilities).forEach(([facility, tasks]) => {
        tasks.forEach((task, index) => {
          // Add the facility name for the first task
          const facilityName = index === 0 ? facility : "";
          sheetData.push([facilityName, task.periodical_name, task.frequency, ...task.monthly_status]);
        });

        // Add an empty row after each facility
        sheetData.push([]);
      });

      // Add an empty row after each state
      sheetData.push([]);
    });

    // Create the worksheet
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // Create the workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `Periodical Clean ${this.state.selectedYear}`);

    // Write the workbook and trigger download
    XLSX.writeFile(wb, `Periodical_Clean_${this.state.selectedYear}.xlsx`);
  }

  render() {
    const columns = this.getMonthHeaders();

    return (
      <BlockUi tag="div" blocking={this.state.loading}>
        <Container fluid={true}>
          <div className="p-4 mt-3 bg-white">
            <div className="overflow-x-auto periodical_status_report">
              <div className="row">
                <div className="col-2">
                  <FormGroup className="year_picker_form_grp">
                    <Label>Year</Label>
                    <YearPicker onChange={this.handleDateChange} ref={this.setDatepickerRef} />
                  </FormGroup>
                </div>
                <div className="col-3">
                  <FormGroup>
                    <Label>Group</Label>
                    <DropDown name={"selected_group"} data={this.state.organizationList} first_element={"--Select Group--"} onChange={this.handleGroupChange} />
                    <span className="error-text">
                      {this.validator.message("selected_group", this.state.groupId, "required|gt:0", false, {
                        default: "This field is required.",
                      })}
                    </span>
                  </FormGroup>
                </div>

                <div className="col-6">
                  <FormGroup>
                    <Label>Facility</Label>
                    <Select
                      name={"selected_facility"}
                      options={this.state.facilityListByOrganization.map(({ name, id }) => {
                        return {
                          label: name,
                          value: id,
                        };
                      })}
                      multi
                      value={this.state.facilityId}
                      onChange={this.handleFacilityChange}
                    />
                    <div className="mt-2">
                      <input id="selectAll" type="checkbox" checked={this.state.isSelectAll} value={this.state.isSelectAll} onClick={this.selectAllFacility} />
                      <label htmlFor="selectAll" className="ml-2">
                        Select All
                      </label>
                    </div>

                    <span className="error-text">
                      {this.validator.message("selected_facility", this.state.facilityId, "required", false, {
                        default: "This field is required.",
                      })}
                    </span>
                  </FormGroup>
                </div>
              </div>
              <div className="col-12 submit_btn">
                <FormGroup>
                  <Button color="primary" disabled={this.state.loading} onClick={this.searchForReport}>
                    Submit
                  </Button>
                </FormGroup>
              </div>
              {Object.keys(this.state.data).length === 0 ? (
                <div className="col-12">
                  <div className="row justify-content-center mt-3 ">
                    <span className="error-text">{this.state.recordNotFoundMessage.message}</span>
                  </div>
                </div>
              ) : (
                <React.Fragment>
                  <div className="d-flex justify-content-end">
                    <Button color="primary" onClick={() => this.createExcelFile(this.state.data)}>
                      Download Excel
                    </Button>
                  </div>
                  <table className="min-w-full consolidate_report">
                    <thead>
                      <tr>
                        <th colSpan={3 + columns.length} className="text-center table_name_th">
                          PERIODICAL CLEAN {this.state.selectedYear}
                        </th>
                      </tr>
                      <tr>
                        <th className="">Facility Name</th>
                        <th className="">Periodical</th>
                        <th className="">Frequency</th>
                        {columns.map((column) => (
                          <th key={column} className="px-4 w-16">
                            {column}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(this.state.data).map((state) => (
                        <React.Fragment key={state}>
                          <tr>
                            <td colSpan={3} className=" text-center state_td">
                              {state}
                            </td>
                          </tr>
                          {Object.keys(this.state.data[state]).map((location) => (
                            <tr key={location}>
                              <td /* rowSpan={this.state.data[location].length} */ className=" location_td">
                                <div> {location} </div>
                              </td>
                              <td className="periodical_td">
                                {this.state.data[state][location].map((item, index) => (
                                  <tr key={index + Math.random()} className="periodical_row">
                                    <td className={index !== this.state.data[state][location].length - 1 ? "periodical_data" : "periodical_data_last"}>{item.periodical_name}</td>
                                  </tr>
                                ))}
                              </td>
                              <td className="periodical_td">
                                {this.state.data[state][location].map((item, index) => (
                                  <tr key={index + Math.random()} className="periodical_row">
                                    <td className={index !== this.state.data[state][location].length - 1 ? "periodical_data" : "periodical_data_last"}>{item.frequency}</td>
                                  </tr>
                                ))}
                              </td>

                              {columns.map((column, index) => (
                                <td key={column} className="text-center ">
                                  {this.state.data[state][location].map((item, locationIndex) => (
                                    <tr key={index + Math.random()} className="periodical_row">
                                      <td
                                        className={locationIndex !== this.state.data[state][location].length - 1 ? "periodical_data" : "periodical_data_last"}
                                        style={{
                                          color: item.monthly_status[index] == "✖" ? "red" : item.monthly_status[index] == "-" ? "black" : "green",
                                          fontSize: item.monthly_status[index] != "✖" ? "20px" : "12px",
                                        }}
                                      >
                                        {item.monthly_status[index]}
                                      </td>
                                    </tr>
                                  ))}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </React.Fragment>
              )}
            </div>
          </div>
        </Container>
      </BlockUi>
    );
  }
}

ConsolidateReport.propTypes = {};

function mapStateToProps(state) {
  const {
    postsBySubreddit: { periodical_status_report_data, group_items, facility_data },
  } = state;

  return { periodical_status_report_data, facility_data, group_items };
}

const ConsolidateContainer = connect(mapStateToProps)(ConsolidateReport);

export default ConsolidateContainer;



// WEBPACK FOOTER //
// ./src/shared/containers/Reports/ConsolidateReport.js